import HeroBanner from '@/components/page-hero-banner';
import VirtualShowRoom from '@/ctf-components/virtual-show-room';
import { SectionIC } from '@/lib/interface-types';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import uuid from 'react-uuid';
import NavigationButton from '../navigationButton';
import PersonBanner from '../person-banner';
import RichText from '../rich-text-article';
import SectionLanding from '../section-landing';
import Section from '../section/section';
import SocialShare from '../social-share';

const SlugPage = ({ data, contentStory }: any) => {
  const router = useRouter();

  const { slug, subCategory } = data || {};
  const richTextContent = contentStory?.content || data.content;

  const accordionLinks = data?.accordion?.links?.entries.block;
  const sectionCollection =
    data?.featuredProjectsCollection?.items[0]?.sectionContentCollection;

  useEffect(() => {
    if (router.isReady) {
      if (!data) {
        router.push('/404');
      }
    }
  }, [router, router.isReady, data]);

  return (
    <main className="container xl:flex mx-auto w-full">
      {!data.landingPage && (
        <div className="flex-auto items-stretch max-[1280px]:hidden">
          <div className="w-[60px] relative h-full">
            <div className="sticky top-1/2">
              <SocialShare flex="flex-col" />
            </div>
          </div>
        </div>
      )}
      <div className={`flex-auto ${data.landingPage ? 'landing-page' : ''}`}>
        <div className="mb-4 md:mb-14">
          {data?.featuredTitle && (
            <>
              <HeroBanner
                title={data?.featuredTitle}
                coloredTitle={false}
                richText={data.featuredDescription}
              />
              {!data.landingPage && (
                <div className="py-6 min-[1280px]:hidden">
                  <SocialShare flex="flex-row" />
                </div>
              )}
            </>
          )}
          {data?.published && (
            <p className="text-grey-base">{data.published}</p>
          )}
          {data?.writtenBy && (
            <p className="text-grey-base">{data.writtenBy}</p>
          )}
        </div>
        {richTextContent && (
          <div
            className={`landing-rich-text ${
              data.landingPage ? 'landing-page' : ''
            }`}
          >
            <RichText data={richTextContent} isLandingType={data.landingPage} />
          </div>
        )}
        {data?.personBanner && (
          <PersonBanner data={data.personBanner} sectionbaner={false} />
        )}
        {data.landingPage &&
          data?.featuredProjectsCollection?.items?.map((section: any) => (
            <Section key={uuid()} section={section} />
          ))}
        {/* <Newsletter /> */}
        {data?.nextPageNavigation && (
          <div className="mt-20">
            <NavigationButton data={data.nextPageNavigation} />
          </div>
        )}
        {accordionLinks?.map((section: SectionIC) => (
          <Section slug={slug} key={uuid()} section={section} />
        ))}
      </div>
      {sectionCollection && !data.landingPage && (
        <div className="flex-auto xl:items-stretch">
          <div className="xl:w-max xl:pl-[80px] pt-12 xl:pt-20 h-full relative">
            <div className="xl:sticky xl:top-[120px] xl:max-w-[400px]">
              {data?.featuredProjectsCollection?.items?.map((section: any) => (
                <SectionLanding
                  key={uuid()}
                  section={section}
                  subCategory={subCategory}
                />
              ))}
              {data?.sidebarNextPageNavigationCollection?.items?.map(
                (section: any) => (
                  <div className="mt-20" key={uuid()}>
                    <NavigationButton data={section} />
                  </div>
                )
              )}
              {data?.virtualShowRoom && (
                <VirtualShowRoom data={data.virtualShowRoom} />
              )}
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default SlugPage;
